module.exports = __webpack_public_path__ + "assets/img/newsBg.3bad154f.png";